<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H400030'}" tag="span"></router-link>
      {{info.I_TITLE}}</div>
    <div class="scroll_area" style="overflow-y: scroll">
      <div v-show="info.I_MP3_QNY && info.I_MP3_QNY.indexOf('.mp4') > -1" class="videoArea">
        <!--<div class="top">-->
          <!--<router-link tag="span" class="icon_back" :to="{name:'H400030'}"></router-link>-->
          <!--<span class="icon_dz" :class="{active: info.I_UPVOTE_FLAG == 'Y'}" @click="dianZan"></span>-->
        <!--</div>-->
        <!--x5-video-player-type="h5"-->
        <video width="100%" height="100%"  id="video" :src="info.I_MP3_QNY"
                controls="controls"  webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow"
               :poster="info.I_ICON_QNY" ></video >
        <div class="videoInfo1">
          <!--<span class="title">{{info.I_TITLE}}</span>-->
          <span class="num">播放&nbsp;&nbsp;{{info.I_PLAY_NUM}}</span>

          <div style="display: flex;justify-content: flex-end"><span style="line-height: 2.4rem;color: #000;font-size: 0.9rem;">赞</span><span class="icon_dz" :class="{active: info.I_UPVOTE_FLAG == 'Y'}" @click="dianZan"></span></div>
        </div>

        <div class="favoriteVideos">
          <p class="favoriteVideos_title">猜你喜欢</p>

          <div v-if="info.dataList.length > 0" class="weui-grids" style="overflow-y: auto">
            <div v-for="item,index in info.dataList" class="weui-grid" :key="index" @click="playVideo(item.I_MUSIC_NO_SYS)">
              <img :src="item.I_ICON_QNY" />
              <p class="title" style="-webkit-box-orient: vertical;">{{item.I_TITLE}}</p>
              <img class="icon_play" src="../assets/images/icon_play1.jpg" alt="">
            </div>
          </div>
        </div>
      </div>

      <div v-show="info.I_MP3_QNY && info.I_MP3_QNY.indexOf('.mp4') == -1" class="audioArea">
        <!--<span class="icon_dz" :class="{active: info.I_UPVOTE_FLAG == 'Y'}" @click="dianZan"></span>-->
        <!--<router-link :to="{name:'H400030'}" tag="span" class="icon_back"></router-link>-->
        <div class="lyric" :class="{active:isShow}"  @click="show">

          <textarea v-if="isShow" readonly>{{info.I_LRC}}</textarea>
        </div>
      </div>
    </div>
    <div v-show="info.I_MP3_QNY && info.I_MP3_QNY.indexOf('.mp4') == -1" class="videoInfo2">
      <!--<span class="title">{{info.I_TITLE}}</span>-->
      <span class="num">播放&nbsp;&nbsp;{{info.I_PLAY_NUM}}</span>
      <div style="display: flex;justify-content: flex-end"><span style="line-height: 2.6rem;color: #000;font-size: 0.9rem;">赞</span>
        <span class="icon_dz" :class="{active: info.I_UPVOTE_FLAG == 'Y'}" @click="dianZan"></span>
      </div>
    </div>
    <audio v-show="info.I_MP3_QNY && info.I_MP3_QNY.indexOf('.mp4') == -1" style="width: 100%;position: fixed;bottom: 0.8rem;height: 4rem;" :src="info.I_MP3_QNY"  controls="controls">
      您的浏览器不支持 audio 标签。
    </audio>

  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {
          I_MP3_QNY: "",
          I_FILM_NO_SYS: "",
          dataList: []
        },
        isShow: false,
      }
    },
    created() {
      let H400040Info = this.$route.params.id
      if(H400040Info) {
        window.localStorage.setItem("H400040", H400040Info)
      } else {
        H400040Info = window.localStorage.getItem("H400040")
      }

      this.init(H400040Info)
      // let param = {
      //   I_MUSIC_NO_SYS: H400040Info
      // }
      // DataRequestFactory.I400040(param).then((response) => {
      //   this.info = response
      // })
    },
    methods: {
      init(id) {
        let vm = this
        let param = {
          I_MUSIC_NO_SYS: id
        }
        DataRequestFactory.I400040(param).then((response) => {
          this.info = response

          this.info.I_MP3_QNY = response.I_MP3_QNY
          this.info.I_ICON_QNY = response.I_ICON_QNY
          // this.info.I_VIDEO_QNY = response.I_VIDEO_QNY

        })
      },
      dianZan() {
        let param = {
          I_MUSIC_NO_SYS: this.info.I_MUSIC_NO_SYS
        }
        DataRequestFactory.I400041(param).then((response) => {
          this.info.I_UPVOTE_FLAG = response.I_UPVOTE_FLAG

        })
      },
      show() {
        this.isShow = !this.isShow
      },
      playVideo(id) {
        // this.init(id)
        window.localStorage.setItem("H400040", id)
        // this.$router.go(0)
        location.reload()
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 8.8
      $(".lyric").css("height", heightDiff + "px")

      let heightDiff1 = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff1 + "px"   )

      // let heightDiff2= screenHeight - parseInt(fontSize) * 7
      // $("#video").css("height", heightDiff2 + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H400040.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H400040.vue